import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  IconButton,
  Divider,
  FormControlLabel,
  Checkbox,
  Radio,
  Box,
  RadioGroup,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import {
  setIsOpenImportDialog,
  useImportExternalSourceData,
} from 'app/store/importExternalSource'
import { FormattedMessage, useIntl } from 'react-intl'
import { importSISDataThunk } from 'app/store/importExternalSource/importExternalSourceReducers'
import ContainedButton from 'app/componentV4/Button/ContainedButton'
import { SECONDARY } from 'app/constants/button'

import useStyles from './styles'

const initialFormData = {
  hasPreferredLanguage: false,
  sendInvitation: false,
}

const DialogImport = () => {
  const dispatch = useDispatch()
  const { isOpenImportDialog } = useImportExternalSourceData()
  const classes = useStyles()
  const [formData, setFormData] = useState(initialFormData)

  const { formatMessage } = useIntl()

  const handleImport = () => {
    dispatch(importSISDataThunk({ ...formData, schoolId: isOpenImportDialog }))
  }

  const onClose = () => {
    dispatch(setIsOpenImportDialog(null))
    setFormData(initialFormData)
  }

  const handleOnChangePrefferedLanguage = (e) => {
    const { value, name } = e.target
    setFormData((prevState) => ({ ...prevState, [name]: value }))
  }

  const handleOnChangeSendInvitation = (e) => {
    const { checked } = e.target
    setFormData((prevState) => ({ ...prevState, sendInvitation: checked }))
  }

  const { sendInvitation, hasPreferredLanguage } = formData

  return (
    <Dialog className={classes.dialogWrap} open={!!isOpenImportDialog}>
      <DialogTitle className={classes.dialogTitle}>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
        <FormattedMessage id="subscribers.importExternalSource.importDialog.title" />
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Box component={'p'} mb={'14px'}>
          <FormattedMessage id="subscribers.importExternalSource.importDialog.description" />
        </Box>
        <Box display={'flex'} flexDirection={'column'}>
          <RadioGroup
            name="hasPreferredLanguage"
            value={`${hasPreferredLanguage}`}
            onChange={handleOnChangePrefferedLanguage}
          >
            <FormControlLabel
              value={'false'}
              className={classes.radioLabel}
              control={<Radio className={classes.radioButton} disableRipple />}
              label={formatMessage({
                id: 'subscribers.importExternalSource.importDialog.radioButton.label1',
              })}
            />
            <FormControlLabel
              value={'true'}
              className={classes.radioLabel}
              control={<Radio className={classes.radioButton} disableRipple />}
              label={formatMessage({
                id: 'subscribers.importExternalSource.importDialog.radioButton.label2',
              })}
            />
          </RadioGroup>
        </Box>
        <Divider className={classes.divider} />
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        {/* <FormControlLabel
          className={classes.checkboxLabel}
          control={
            <Checkbox
              className={classes.checkbox}
              checked={sendInvitation}
              onChange={handleOnChangeSendInvitation}
              disableRipple
            />
          }
          label={formatMessage({
            id: 'subscribers.importExternalSource.importDialog.checkboxButton.label',
          })}
        /> */}
        <ContainedButton
          size="small"
          color={SECONDARY}
          onClick={handleImport}
          className={'h-36 w-full md:w-fit text-14'}
        >
          <FormattedMessage id="subscribers.importExternalSource.importDialog.button.label" />
        </ContainedButton>
      </DialogActions>
    </Dialog>
  )
}

export default DialogImport
